import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interest: null,
};

export const InterestSlice = createSlice({
  name: "InterestSlice",
  initialState,
  reducers: {
    setInterest: (state, { payload }) => {
      state.interest = payload;
      console.log(payload, "@all payload interest");
    },
    setCreateInterest: (state, { payload }) => {
      state.interest = [...state.interest, payload];
    },
    setUpdateInterest: (state, { payload }) => {
      const { _id } = payload;
      console.log(payload, "@Update payload interest");
      state.interest = state.interest.map((item) => {
        if (item._id === _id) {
          return { ...item, ...payload };
        }
        return item;
      });
    },
    setDeleteInterest: (state, { payload }) => {
      const { _id } = payload;
      state.interest = state.interest.filter((item) => item._id !== _id);
    },
    setArchiveInterest: (state, { payload }) => {
      console.log(payload, "@archive payload interest");
      const { _id } = payload;
      state.interest = state.interest.map((item) => {
        if (item._id === _id) {
          return { ...item, ...payload };
        }
        return item;
      });
    },
  },
});

export const {
  setInterest,
  setCreateInterest,
  setUpdateInterest,
  setDeleteInterest,
  setArchiveInterest,
} = InterestSlice.actions;
export default InterestSlice.reducer;
